export const translations = {
  en: {
    // ── Sidebar ────────────────────────────────────────────────────────────────
    'nav.dashboard':       'Dashboard',
    'nav.pipeline_group':  'Pipeline',
    'nav.contacts':        'Contacts',
    'nav.pipeline_board':  'Pipeline Board',
    'nav.opportunities':   'Opportunities',
    'nav.flow_group':      'Flow',
    'nav.projects':        'Projects',
    'nav.task_board':      'Tasks',
    'nav.notes':           'Notes',
    'nav.documents':       'Documents',
    'nav.esignature':      'eSignature',
    'nav.qrcodes':         'QR Codes',
    'nav.scheduling':      'Scheduling',
    'nav.signal_group':    'Signal',
    'nav.social_calendar': 'Social Calendar',
    'nav.campaigns':       'Campaigns',
    'nav.reporting':       'Reporting',
    'nav.interviews':      'Interviews',
    'nav.manage_group':    'Harbour Master',
    'nav.catch_group':     'The Catch',
    'nav.stage_group':     'The Stage',
    'nav.tally_group':     'The Tally',
    'nav.yarns_group':     'The Yarns',
    'nav.invoices':        'Invoices',
    'nav.expenses':        'Expenses',
    'nav.time':            'Time',
    'nav.quotes':          'Quotes',
    'nav.clients':         'Clients',
    'nav.yarns':           'Yarns',
    'nav.twine':           'The Twine',
    'nav.bulletin':        'Bulletin',
    'nav.signups':         'Sign-ups',
    'nav.my_card':         'My card',
    'nav.configuration':   'Configuration',
    'nav.team_members':    'Team Members',
    'nav.company':         'Company',
    'nav.companies':       'Companies',
    'nav.logout':          'Logout',
    'nav.soon':            'Soon',
    'nav.language':        'Language',

    // ── TopBar ─────────────────────────────────────────────────────────────────
    'topbar.search':          'Search...',
    'topbar.new':             'New',
    'topbar.notifications':   'Notifications',
    'topbar.mark_all_read':   'Mark all read',
    'topbar.no_notifications':'No notifications yet',
    'topbar.new_contact':     'New Contact',
    'topbar.new_task':        'New Task',
    'topbar.new_sequence':    'New Sequence',
    'topbar.new_social_post': 'New Social Post',

    // ── Common ─────────────────────────────────────────────────────────────────
    'common.save':       'Save',
    'common.cancel':     'Cancel',
    'common.edit':       'Edit',
    'common.delete':     'Delete',
    'common.create':     'Create',
    'common.search':     'Search',
    'common.loading':    'Loading...',
    'common.assign':     'Assign',
    'common.assigning':  'Assigning...',
    'common.deleting':   'Deleting...',
    'common.importing':  'Importing...',
    'common.uploading':  'Uploading...',
    'common.all':        'All',
    'common.close':      'Close',
    'common.add':        'Add',
    'common.yes':        'Yes',
    'common.no':         'No',
    'common.or':         'or',
    'common.name':       'Name',
    'common.email':      'Email',
    'common.phone':      'Phone',
    'common.company':    'Company',
    'common.notes':      'Notes',
    'common.source':     'Source',
    'common.type':       'Type',
    'common.status':     'Status',
    'common.stage':      'Stage',
    'common.project':    'Project',
    'common.assigned_to':'Assigned To',
    'common.created':    'Created',
    'common.updated':    'Updated',
    'common.actions':    'Actions',
    'common.no_company': 'No company',
    'common.unassigned': 'Unassigned',
    'common.unknown':    'Unknown',
    'common.none':       '—',
    'common.dismiss':    'Dismiss',
    'common.download':   'Download',
    'common.upload':     'Upload',
    'common.import':     'Import',
    'common.export':     'Export',
    'common.preview':    'Preview',
    'common.copy':       'Copy',
    'common.select':     'Select',
    'common.required':   'required',
    'common.optional':   'optional',
    'common.default':    'default',

    // ── Dashboard ──────────────────────────────────────────────────────────────
    'dashboard.title':              'Dashboard',
    'dashboard.greet_morning':      'Good morning',
    'dashboard.greet_afternoon':    'Good afternoon',
    'dashboard.greet_evening':      'Good evening',
    'dashboard.harbour_loading':    'Checking what has come in…',
    'dashboard.harbour_line':       '{tasks} open tasks and {campaigns} active campaigns are tied up at the stagehead.',
    'dashboard.open_pipeline':      'Open pipeline',
    'dashboard.open_tasks_btn':     'Task board',
    'dashboard.total_contacts':     'Total Contacts',
    'dashboard.active_campaigns':   'Active Campaigns',
    'dashboard.open_tasks':         'Open Tasks',
    'dashboard.social_published':   'Social Published',
    'dashboard.win_rate':           'Win Rate',
    'dashboard.projects':           'Projects',
    'dashboard.active_projects':    'active projects',
    'dashboard.active_project':     'active project',
    'dashboard.no_projects':        'No projects yet',
    'dashboard.no_projects_desc':   'Create your first project to get started.',
    'dashboard.recent_activity':    'Recent Activity',
    'dashboard.no_recent_activity': 'No recent activity',
    'dashboard.contacts':           'contacts',
    'dashboard.campaigns':          'campaigns',
    'dashboard.tasks':              'tasks',
    'dashboard.won':                'won',
    'dashboard.no_contacts':        'No contacts yet',
    'dashboard.loading_dashboard':  'Failed to load dashboard',
    'dashboard.stage_change':       'Stage change',

    // ── Contacts ───────────────────────────────────────────────────────────────
    'contacts.title':              'Contacts',
    'contacts.add_contact':        'Add Contact',
    'contacts.import_csv':         'Import CSV',
    'contacts.search':             'Search contacts…',
    'contacts.all_projects':       'All Projects',
    'contacts.all_stages':         'All Stages',
    'contacts.all_types':          'All Types',
    'contacts.all_reps':           'All Reps',
    'contacts.all_sources':        'All Sources',
    'contacts.clear_filters':      'Clear',
    'contacts.showing':            'Showing',
    'contacts.contacts':           'contacts',
    'contacts.selected':           'selected',
    'contacts.assign_project':     'Assign Project',
    'contacts.assign_rep':         'Assign Rep',
    'contacts.col_name':           'Name',
    'contacts.col_company':        'Company',
    'contacts.col_contact_info':   'Contact Info',
    'contacts.col_type':           'Type',
    'contacts.col_stage':          'Stage',
    'contacts.col_source':         'Source',
    'contacts.col_created':        'Created',
    'contacts.loading':            'Loading contacts...',
    'contacts.none_found':         'No contacts found',
    'contacts.contact_info':       'Contact Information',
    'contacts.activity_feed':      'Activity Feed',
    'contacts.files':              'Files',
    'contacts.no_files':           'No files uploaded',
    'contacts.upload_file':        'Upload File',
    'contacts.uploading_file':     'Uploading...',
    'contacts.loading_files':      'Loading files...',
    'contacts.loading_activities': 'Loading activities...',
    'contacts.no_activities':      'No activities yet',
    'contacts.delete_contact':     'Delete Contact',
    'contacts.confirm_delete':     'Permanently delete this contact?',
    'contacts.position_title':     'Position / Title',
    'contacts.linkedin_url':       'LinkedIn URL',
    'contacts.contact_type':       'Contact Type',
    'contacts.save_activity':      'Save Activity',
    'contacts.full_name':          'Full Name',
    'contacts.full_name_required': 'Full name is required',
    'contacts.email_required':     'Valid email is required',
    'contacts.contact_type_required': 'Contact type is required',
    'contacts.log_call':           'Log Call',
    'contacts.log_email':          'Log Email',
    'contacts.log_linkedin':       'LinkedIn',
    'contacts.log_note':           'Note',
    'contacts.log_meeting':        'Meeting',
    'contacts.log':                'Log',
    'contacts.subject':            'Subject',
    'contacts.details':            'Details...',
    'contacts.new_contact_title':  'Create New Contact',
    'contacts.new_contact_desc':   'Add a new contact to your CRM',
    'contacts.create_contact':     'Create Contact',
    'contacts.select_project':     'Select project',
    'contacts.select_type':        'Select type',
    'contacts.select_source':      'Select source (optional)',
    'contacts.eg_sales_manager':   'e.g. Sales Manager',
    'contacts.assigned_email':     'email@example.com',
    'contacts.csv_title':          'Import Contacts from CSV',
    'contacts.csv_desc':           'Upload a CSV file to import multiple contacts at once',
    'contacts.csv_instructions':   'Instructions',
    'contacts.csv_required_cols':  'Required columns',
    'contacts.csv_apollo':         'Apollo exports are supported natively',
    'contacts.csv_optional':       'Optional',
    'contacts.download_template':  'Download Template',
    'contacts.upload_csv':         'Upload CSV File',
    'contacts.assign_project_default': 'Assign to Project',
    'contacts.contact_type_default': 'Contact Type',
    'contacts.preview_rows':       'Preview (First 5 rows)',
    'contacts.import_contacts':    'Import Contacts',
    'contacts.bulk_delete_title':  'Delete contacts?',
    'contacts.bulk_delete_desc':   'This will permanently remove the selected contacts and all their activity history. This cannot be undone.',
    'contacts.assign_to_project':  'Assign contacts to project',
    'contacts.assign_to_rep':      'Assign contacts to rep',
    'contacts.choose_project':     'Choose a project...',
    'contacts.choose_rep':         'Choose a rep...',
    'contacts.stage_updated':      'Stage updated to',
    'contacts.contact_updated':    'Contact updated successfully',
    'contacts.contact_created':    'Contact created successfully',
    'contacts.contact_deleted':    'Contact deleted',
    'contacts.activity_logged':    'Activity logged',
    'contacts.file_uploaded':      'File uploaded successfully',
    'contacts.file_deleted':       'File deleted',
    'contacts.something_wrong':    'Something went wrong displaying this contact.',

    // ── Pipeline ───────────────────────────────────────────────────────────────
    'pipeline.title':           'Pipeline',
    'pipeline.search':          'Search all contacts...',
    'pipeline.all_types':       'All Types',
    'pipeline.new_contact':     'New Contact',
    'pipeline.loading':         'Loading pipeline...',
    'pipeline.no_projects':     'No active projects found.',
    'pipeline.add_contact':     'Add contact',
    'pipeline.empty':           'Empty',
    'pipeline.total_contacts':  'total contacts across',
    'pipeline.project':         'project',
    'pipeline.projects':        'projects',
    'pipeline.log_activity':    'Log activity',
    'pipeline.log_call':        'Log Call',
    'pipeline.log_email':       'Log Email',
    'pipeline.log_linkedin':    'LinkedIn',
    'pipeline.log_note':        'Add Note',
    'pipeline.activity':        'Activity',
    'pipeline.no_activities':   'No activities yet',
    'pipeline.stage':           'Stage',
    'pipeline.save':            'Save',
    'pipeline.cancel':          'Cancel',
    'pipeline.assigned_to':     'Assigned to',
    'pipeline.unassigned':      'Unassigned',
    'pipeline.new_contact_title': 'New Contact',
    'pipeline.new_contact_desc':  'Add a new contact to the pipeline',
    'pipeline.select_project':  'Select project',
    'pipeline.select_type':     'Select type',
    'pipeline.select_source':   'Select source',
    'pipeline.create_contact':  'Create Contact',
    'pipeline.subject_optional':'Subject (optional)',
    'pipeline.notes':           'Notes...',
    'pipeline.stage_updated':   'Stage updated',
    'pipeline.contact_created': 'Contact created',
    'pipeline.moved_to':        'Moved to',

    // ── Opportunities ──────────────────────────────────────────────────────────
    'opportunities.title':          'Opportunities',
    'opportunities.search':         'Search opportunities...',
    'opportunities.all_projects':   'All Projects',
    'opportunities.all_stages':     'All Stages',
    'opportunities.all_types':      'All Types',
    'opportunities.loading':        'Loading opportunities...',
    'opportunities.none':           'No opportunities found',
    'opportunities.contact':        'Contact',
    'opportunities.stage':          'Stage',
    'opportunities.value':          'Value',
    'opportunities.close_date':     'Close Date',
    'opportunities.probability':    'Probability',
    'opportunities.assigned_to':    'Assigned To',

    // ── Tasks ──────────────────────────────────────────────────────────────────
    'tasks.title':           'Task Board',
    'tasks.new_task':        'New Task',
    'tasks.search':          'Search tasks...',
    'tasks.backlog':         'Backlog',
    'tasks.in_progress':     'In Progress',
    'tasks.review':          'Review',
    'tasks.done':            'Done',
    'tasks.priority_low':    'Low',
    'tasks.priority_medium': 'Medium',
    'tasks.priority_high':   'High',
    'tasks.priority_urgent': 'Urgent',
    'tasks.type_internal':   'Internal',
    'tasks.type_dev':        'Dev',
    'tasks.type_design':     'Design',
    'tasks.type_marketing':  'Marketing',
    'tasks.type_client':     'Client Request',
    'tasks.loading':         'Loading tasks...',
    'tasks.none_found':      'No tasks found',
    'tasks.create_task':     'Create Task',
    'tasks.edit_task':       'Edit Task',
    'tasks.delete_task':     'Delete Task',
    'tasks.confirm_delete':  'Are you sure you want to delete this task?',
    'tasks.task_title':      'Task Title',
    'tasks.description':     'Description',
    'tasks.priority':        'Priority',
    'tasks.type':            'Type',
    'tasks.due_date':        'Due Date',
    'tasks.assignee':        'Assignee',
    'tasks.overdue':         'Overdue',
    'tasks.due_today':       'Due today',
    'tasks.all_projects':    'All Projects',
    'tasks.all_priorities':  'All Priorities',
    'tasks.all_types':       'All Types',
    'tasks.stats':           'Stats',
    'tasks.total':           'Total',
    'tasks.completed':       'Completed',
    'tasks.open':            'Open',
    'tasks.task_created':    'Task created',
    'tasks.task_updated':    'Task updated',
    'tasks.task_deleted':    'Task deleted',

    // ── Sequences / Campaigns ──────────────────────────────────────────────────
    'sequences.title':           'Campaigns',
    'sequences.new_campaign':    'New Campaign',
    'sequences.search':          'Search campaigns...',
    'sequences.loading':         'Loading campaigns...',
    'sequences.none':            'No campaigns yet',
    'sequences.none_desc':       'Create your first email campaign to get started.',
    'sequences.create':          'Create Campaign',
    'sequences.edit':            'Edit Campaign',
    'sequences.delete':          'Delete Campaign',
    'sequences.confirm_delete':  'Are you sure you want to delete this campaign?',
    'sequences.campaign_name':   'Campaign Name',
    'sequences.description':     'Description',
    'sequences.status':          'Status',
    'sequences.active':          'Active',
    'sequences.paused':          'Paused',
    'sequences.completed':       'Completed',
    'sequences.steps':           'Steps',
    'sequences.contacts':        'Contacts',
    'sequences.add_step':        'Add Step',
    'sequences.step_delay':      'Delay (days)',
    'sequences.email_subject':   'Email Subject',
    'sequences.email_body':      'Email Body',
    'sequences.enroll_contacts': 'Enroll Contacts',
    'sequences.enrolled':        'Enrolled',
    'sequences.all_types':       'All Types',
    'sequences.day':             'day',
    'sequences.days':            'days',
    'sequences.delay':           'Delay',
    'sequences.overview':        'Overview',
    'sequences.sent':            'Sent',
    'sequences.opened':          'Opened',
    'sequences.clicked':         'Clicked',
    'sequences.replied':         'Replied',
    'sequences.unsubscribed':    'Unsubscribed',

    // ── Social Calendar ────────────────────────────────────────────────────────
    'social.title':          'Social Calendar',
    'social.new_post':       'New Post',
    'social.schedule':       'Schedule',
    'social.publish':        'Publish',
    'social.draft':          'Draft',
    'social.published':      'Published',
    'social.scheduled':      'Scheduled',
    'social.loading':        'Loading social posts...',
    'social.no_posts':       'No posts yet',
    'social.create_post':    'Create Post',
    'social.edit_post':      'Edit Post',
    'social.delete_post':    'Delete Post',
    'social.content':        'Content',
    'social.platform':       'Platform',
    'social.schedule_date':  'Schedule Date',
    'social.all_platforms':  'All Platforms',
    'social.all_statuses':   'All Statuses',

    // ── Reporting ──────────────────────────────────────────────────────────────
    'reporting.title':         'Reporting',
    'reporting.loading':       'Loading reports...',
    'reporting.no_data':       'No data available',
    'reporting.total_contacts':'Total Contacts',
    'reporting.by_stage':      'By Stage',
    'reporting.by_type':       'By Type',
    'reporting.by_source':     'By Source',
    'reporting.win_rate':      'Win Rate',
    'reporting.activity':      'Activity',
    'reporting.this_month':    'This Month',
    'reporting.all_time':      'All Time',

    // ── Documents ──────────────────────────────────────────────────────────────
    'documents.title':          'Documents',
    'documents.new_document':   'New Document',
    'documents.loading':        'Loading documents...',
    'documents.none':           'No documents yet',
    'documents.upload':         'Upload Document',
    'documents.send_for_sign':  'Send for Signature',
    'documents.signed':         'Signed',
    'documents.pending':        'Pending',
    'documents.draft':          'Draft',
    'documents.download':       'Download',
    'documents.delete':         'Delete',

    // ── QR Codes ───────────────────────────────────────────────────────────────
    'qrcodes.title':      'QR Codes',
    'qrcodes.new':        'New QR Code',
    'qrcodes.loading':    'Loading QR codes...',
    'qrcodes.none':       'No QR codes yet',
    'qrcodes.name':       'Name',
    'qrcodes.url':        'URL',
    'qrcodes.create':     'Create QR Code',
    'qrcodes.download':   'Download',
    'qrcodes.delete':     'Delete',
    'qrcodes.scans':      'Scans',

    // ── Scheduling ─────────────────────────────────────────────────────────────
    'scheduling.title':       'Scheduling',
    'scheduling.coming_soon': 'Scheduling coming soon',

    // ── Settings ───────────────────────────────────────────────────────────────
    'settings.company_title':    'Company Settings',
    'settings.team_title':       'Team Members',
    'settings.projects_title':   'Projects',
    'settings.company_name':     'Company Name',
    'settings.company_logo':     'Company Logo',
    'settings.upload_logo':      'Upload Logo',
    'settings.save_changes':     'Save Changes',
    'settings.invite_member':    'Invite Member',
    'settings.invite_email':     'Email address',
    'settings.send_invite':      'Send Invite',
    'settings.member_name':      'Name',
    'settings.member_email':     'Email',
    'settings.member_role':      'Role',
    'settings.member_status':    'Status',
    'settings.active':           'Active',
    'settings.inactive':         'Inactive',
    'settings.admin':            'Admin',
    'settings.member':           'Member',
    'settings.loading_team':     'Loading team...',
    'settings.no_team':          'No team members yet',
    'settings.new_project':      'New Project',
    'settings.project_name':     'Project Name',
    'settings.project_color':    'Project Color',
    'settings.project_desc':     'Description',
    'settings.create_project':   'Create Project',
    'settings.edit_project':     'Edit Project',
    'settings.delete_project':   'Delete Project',
    'settings.no_projects':      'No projects yet',
    'settings.loading_projects': 'Loading projects...',

    // ── Auth ───────────────────────────────────────────────────────────────────
    'auth.login_title':     'Welcome back',
    'auth.login_desc':      'Sign in to Stagehead OS',
    'auth.email':           'Email',
    'auth.password':        'Password',
    'auth.sign_in':         'Sign In',
    'auth.signing_in':      'Signing in...',
    'auth.forgot_password': 'Forgot password?',
    'auth.loading':         'Loading Stagehead OS...',
    'auth.accept_invite':   'Accept Invitation',
    'auth.create_account':  'Create Account',
    'auth.full_name':       'Full Name',
  },

  es: {
    // ── Sidebar ────────────────────────────────────────────────────────────────
    'nav.dashboard':       'Inicio',
    'nav.pipeline_group':  'Pipeline',
    'nav.contacts':        'Contactos',
    'nav.pipeline_board':  'Tablero de Pipeline',
    'nav.opportunities':   'Oportunidades',
    'nav.flow_group':      'Flujo',
    'nav.projects':        'Proyectos',
    'nav.task_board':      'Tareas',
    'nav.notes':           'Notas',
    'nav.documents':       'Documentos',
    'nav.esignature':      'Firma electrónica',
    'nav.qrcodes':         'Códigos QR',
    'nav.scheduling':      'Programación',
    'nav.signal_group':    'Signal',
    'nav.social_calendar': 'Calendario Social',
    'nav.campaigns':       'Campañas',
    'nav.reporting':       'Reportes',
    'nav.interviews':      'Entrevistas',
    'nav.manage_group':    'Harbour Master',
    'nav.catch_group':     'The Catch',
    'nav.stage_group':     'The Stage',
    'nav.tally_group':     'The Tally',
    'nav.yarns_group':     'The Yarns',
    'nav.invoices':        'Facturas',
    'nav.expenses':        'Gastos',
    'nav.time':            'Tiempo',
    'nav.quotes':          'Cotizaciones',
    'nav.clients':         'Clientes',
    'nav.yarns':           'Yarns',
    'nav.twine':           'The Twine',
    'nav.bulletin':        'Boletín',
    'nav.signups':         'Voluntarios',
    'nav.my_card':         'Mi tarjeta',
    'nav.configuration':   'Configuración',
    'nav.team_members':    'Equipo',
    'nav.company':         'Empresa',
    'nav.companies':       'Empresas',
    'nav.logout':          'Cerrar sesión',
    'nav.soon':            'Pronto',
    'nav.language':        'Idioma',

    // ── TopBar ─────────────────────────────────────────────────────────────────
    'topbar.search':           'Buscar...',
    'topbar.new':              'Nuevo',
    'topbar.notifications':    'Notificaciones',
    'topbar.mark_all_read':    'Marcar todo como leído',
    'topbar.no_notifications': 'Sin notificaciones',
    'topbar.new_contact':      'Nuevo Contacto',
    'topbar.new_task':         'Nueva Tarea',
    'topbar.new_sequence':     'Nueva Campaña',
    'topbar.new_social_post':  'Nueva Publicación',

    // ── Common ─────────────────────────────────────────────────────────────────
    'common.save':       'Guardar',
    'common.cancel':     'Cancelar',
    'common.edit':       'Editar',
    'common.delete':     'Eliminar',
    'common.create':     'Crear',
    'common.search':     'Buscar',
    'common.loading':    'Cargando...',
    'common.assign':     'Asignar',
    'common.assigning':  'Asignando...',
    'common.deleting':   'Eliminando...',
    'common.importing':  'Importando...',
    'common.uploading':  'Subiendo...',
    'common.all':        'Todos',
    'common.close':      'Cerrar',
    'common.add':        'Agregar',
    'common.yes':        'Sí',
    'common.no':         'No',
    'common.or':         'o',
    'common.name':       'Nombre',
    'common.email':      'Correo',
    'common.phone':      'Teléfono',
    'common.company':    'Empresa',
    'common.notes':      'Notas',
    'common.source':     'Fuente',
    'common.type':       'Tipo',
    'common.status':     'Estado',
    'common.stage':      'Etapa',
    'common.project':    'Proyecto',
    'common.assigned_to':'Asignado a',
    'common.created':    'Creado',
    'common.updated':    'Actualizado',
    'common.actions':    'Acciones',
    'common.no_company': 'Sin empresa',
    'common.unassigned': 'Sin asignar',
    'common.unknown':    'Desconocido',
    'common.none':       '—',
    'common.dismiss':    'Cerrar',
    'common.download':   'Descargar',
    'common.upload':     'Subir',
    'common.import':     'Importar',
    'common.export':     'Exportar',
    'common.preview':    'Vista previa',
    'common.copy':       'Copiar',
    'common.select':     'Seleccionar',
    'common.required':   'requerido',
    'common.optional':   'opcional',
    'common.default':    'predeterminado',

    // ── Dashboard ──────────────────────────────────────────────────────────────
    'dashboard.title':              'Inicio',
    'dashboard.greet_morning':      'Buenos días',
    'dashboard.greet_afternoon':    'Buenas tardes',
    'dashboard.greet_evening':      'Buenas noches',
    'dashboard.harbour_loading':    'Revisando lo que ha llegado…',
    'dashboard.harbour_line':       '{tasks} tareas abiertas y {campaigns} campañas activas esperan en el muelle.',
    'dashboard.open_pipeline':      'Abrir pipeline',
    'dashboard.open_tasks_btn':     'Tablero de tareas',
    'dashboard.total_contacts':     'Total de Contactos',
    'dashboard.active_campaigns':   'Campañas Activas',
    'dashboard.open_tasks':         'Tareas Abiertas',
    'dashboard.social_published':   'Publicaciones Sociales',
    'dashboard.win_rate':           'Tasa de Cierre',
    'dashboard.projects':           'Proyectos',
    'dashboard.active_projects':    'proyectos activos',
    'dashboard.active_project':     'proyecto activo',
    'dashboard.no_projects':        'Sin proyectos aún',
    'dashboard.no_projects_desc':   'Crea tu primer proyecto para comenzar.',
    'dashboard.recent_activity':    'Actividad Reciente',
    'dashboard.no_recent_activity': 'Sin actividad reciente',
    'dashboard.contacts':           'contactos',
    'dashboard.campaigns':          'campañas',
    'dashboard.tasks':              'tareas',
    'dashboard.won':                'ganados',
    'dashboard.no_contacts':        'Sin contactos aún',
    'dashboard.loading_dashboard':  'Error al cargar el tablero',
    'dashboard.stage_change':       'Cambio de etapa',

    // ── Contacts ───────────────────────────────────────────────────────────────
    'contacts.title':              'Contactos',
    'contacts.add_contact':        'Agregar Contacto',
    'contacts.import_csv':         'Importar CSV',
    'contacts.search':             'Buscar contactos…',
    'contacts.all_projects':       'Todos los Proyectos',
    'contacts.all_stages':         'Todas las Etapas',
    'contacts.all_types':          'Todos los Tipos',
    'contacts.all_reps':           'Todos los Reps',
    'contacts.all_sources':        'Todas las Fuentes',
    'contacts.clear_filters':      'Limpiar',
    'contacts.showing':            'Mostrando',
    'contacts.contacts':           'contactos',
    'contacts.selected':           'seleccionados',
    'contacts.assign_project':     'Asignar Proyecto',
    'contacts.assign_rep':         'Asignar Rep',
    'contacts.col_name':           'Nombre',
    'contacts.col_company':        'Empresa',
    'contacts.col_contact_info':   'Información de Contacto',
    'contacts.col_type':           'Tipo',
    'contacts.col_stage':          'Etapa',
    'contacts.col_source':         'Fuente',
    'contacts.col_created':        'Creado',
    'contacts.loading':            'Cargando contactos...',
    'contacts.none_found':         'No se encontraron contactos',
    'contacts.contact_info':       'Información de Contacto',
    'contacts.activity_feed':      'Historial de Actividad',
    'contacts.files':              'Archivos',
    'contacts.no_files':           'Sin archivos adjuntos',
    'contacts.upload_file':        'Subir Archivo',
    'contacts.uploading_file':     'Subiendo...',
    'contacts.loading_files':      'Cargando archivos...',
    'contacts.loading_activities': 'Cargando actividades...',
    'contacts.no_activities':      'Sin actividades aún',
    'contacts.delete_contact':     'Eliminar Contacto',
    'contacts.confirm_delete':     '¿Eliminar este contacto permanentemente?',
    'contacts.position_title':     'Cargo / Título',
    'contacts.linkedin_url':       'URL de LinkedIn',
    'contacts.contact_type':       'Tipo de Contacto',
    'contacts.save_activity':      'Guardar Actividad',
    'contacts.full_name':          'Nombre Completo',
    'contacts.full_name_required': 'El nombre completo es requerido',
    'contacts.email_required':     'Se requiere un correo válido',
    'contacts.contact_type_required': 'El tipo de contacto es requerido',
    'contacts.log_call':           'Registrar Llamada',
    'contacts.log_email':          'Registrar Correo',
    'contacts.log_linkedin':       'LinkedIn',
    'contacts.log_note':           'Nota',
    'contacts.log_meeting':        'Reunión',
    'contacts.log':                'Registrar',
    'contacts.subject':            'Asunto',
    'contacts.details':            'Detalles...',
    'contacts.new_contact_title':  'Crear Nuevo Contacto',
    'contacts.new_contact_desc':   'Agrega un nuevo contacto a tu CRM',
    'contacts.create_contact':     'Crear Contacto',
    'contacts.select_project':     'Seleccionar proyecto',
    'contacts.select_type':        'Seleccionar tipo',
    'contacts.select_source':      'Seleccionar fuente (opcional)',
    'contacts.eg_sales_manager':   'ej. Gerente de Ventas',
    'contacts.assigned_email':     'correo@ejemplo.com',
    'contacts.csv_title':          'Importar Contactos desde CSV',
    'contacts.csv_desc':           'Sube un archivo CSV para importar múltiples contactos',
    'contacts.csv_instructions':   'Instrucciones',
    'contacts.csv_required_cols':  'Columnas requeridas',
    'contacts.csv_apollo':         'Las exportaciones de Apollo son compatibles nativamente',
    'contacts.csv_optional':       'Opcional',
    'contacts.download_template':  'Descargar Plantilla',
    'contacts.upload_csv':         'Subir Archivo CSV',
    'contacts.assign_project_default': 'Asignar a Proyecto',
    'contacts.contact_type_default': 'Tipo de Contacto',
    'contacts.preview_rows':       'Vista previa (primeras 5 filas)',
    'contacts.import_contacts':    'Importar Contactos',
    'contacts.bulk_delete_title':  '¿Eliminar contactos?',
    'contacts.bulk_delete_desc':   'Esto eliminará permanentemente los contactos seleccionados y todo su historial. No se puede deshacer.',
    'contacts.assign_to_project':  'Asignar contactos a proyecto',
    'contacts.assign_to_rep':      'Asignar contactos a rep',
    'contacts.choose_project':     'Elige un proyecto...',
    'contacts.choose_rep':         'Elige un rep...',
    'contacts.stage_updated':      'Etapa actualizada a',
    'contacts.contact_updated':    'Contacto actualizado correctamente',
    'contacts.contact_created':    'Contacto creado correctamente',
    'contacts.contact_deleted':    'Contacto eliminado',
    'contacts.activity_logged':    'Actividad registrada',
    'contacts.file_uploaded':      'Archivo subido correctamente',
    'contacts.file_deleted':       'Archivo eliminado',
    'contacts.something_wrong':    'Ocurrió un error al mostrar este contacto.',

    // ── Pipeline ───────────────────────────────────────────────────────────────
    'pipeline.title':           'Pipeline',
    'pipeline.search':          'Buscar todos los contactos...',
    'pipeline.all_types':       'Todos los Tipos',
    'pipeline.new_contact':     'Nuevo Contacto',
    'pipeline.loading':         'Cargando pipeline...',
    'pipeline.no_projects':     'No se encontraron proyectos activos.',
    'pipeline.add_contact':     'Agregar contacto',
    'pipeline.empty':           'Vacío',
    'pipeline.total_contacts':  'contactos en total en',
    'pipeline.project':         'proyecto',
    'pipeline.projects':        'proyectos',
    'pipeline.log_activity':    'Registrar actividad',
    'pipeline.log_call':        'Registrar Llamada',
    'pipeline.log_email':       'Registrar Correo',
    'pipeline.log_linkedin':    'LinkedIn',
    'pipeline.log_note':        'Agregar Nota',
    'pipeline.activity':        'Actividad',
    'pipeline.no_activities':   'Sin actividades aún',
    'pipeline.stage':           'Etapa',
    'pipeline.save':            'Guardar',
    'pipeline.cancel':          'Cancelar',
    'pipeline.assigned_to':     'Asignado a',
    'pipeline.unassigned':      'Sin asignar',
    'pipeline.new_contact_title': 'Nuevo Contacto',
    'pipeline.new_contact_desc':  'Agrega un nuevo contacto al pipeline',
    'pipeline.select_project':  'Seleccionar proyecto',
    'pipeline.select_type':     'Seleccionar tipo',
    'pipeline.select_source':   'Seleccionar fuente',
    'pipeline.create_contact':  'Crear Contacto',
    'pipeline.subject_optional':'Asunto (opcional)',
    'pipeline.notes':           'Notas...',
    'pipeline.stage_updated':   'Etapa actualizada',
    'pipeline.contact_created': 'Contacto creado',
    'pipeline.moved_to':        'Movido a',

    // ── Opportunities ──────────────────────────────────────────────────────────
    'opportunities.title':          'Oportunidades',
    'opportunities.search':         'Buscar oportunidades...',
    'opportunities.all_projects':   'Todos los Proyectos',
    'opportunities.all_stages':     'Todas las Etapas',
    'opportunities.all_types':      'Todos los Tipos',
    'opportunities.loading':        'Cargando oportunidades...',
    'opportunities.none':           'No se encontraron oportunidades',
    'opportunities.contact':        'Contacto',
    'opportunities.stage':          'Etapa',
    'opportunities.value':          'Valor',
    'opportunities.close_date':     'Fecha de Cierre',
    'opportunities.probability':    'Probabilidad',
    'opportunities.assigned_to':    'Asignado a',

    // ── Tasks ──────────────────────────────────────────────────────────────────
    'tasks.title':           'Tablero de Tareas',
    'tasks.new_task':        'Nueva Tarea',
    'tasks.search':          'Buscar tareas...',
    'tasks.backlog':         'Pendiente',
    'tasks.in_progress':     'En Progreso',
    'tasks.review':          'En Revisión',
    'tasks.done':            'Completado',
    'tasks.priority_low':    'Baja',
    'tasks.priority_medium': 'Media',
    'tasks.priority_high':   'Alta',
    'tasks.priority_urgent': 'Urgente',
    'tasks.type_internal':   'Interno',
    'tasks.type_dev':        'Dev',
    'tasks.type_design':     'Diseño',
    'tasks.type_marketing':  'Marketing',
    'tasks.type_client':     'Cliente',
    'tasks.loading':         'Cargando tareas...',
    'tasks.none_found':      'No se encontraron tareas',
    'tasks.create_task':     'Crear Tarea',
    'tasks.edit_task':       'Editar Tarea',
    'tasks.delete_task':     'Eliminar Tarea',
    'tasks.confirm_delete':  '¿Seguro que deseas eliminar esta tarea?',
    'tasks.task_title':      'Título de la Tarea',
    'tasks.description':     'Descripción',
    'tasks.priority':        'Prioridad',
    'tasks.type':            'Tipo',
    'tasks.due_date':        'Fecha Límite',
    'tasks.assignee':        'Asignado a',
    'tasks.overdue':         'Vencida',
    'tasks.due_today':       'Vence hoy',
    'tasks.all_projects':    'Todos los Proyectos',
    'tasks.all_priorities':  'Todas las Prioridades',
    'tasks.all_types':       'Todos los Tipos',
    'tasks.stats':           'Estadísticas',
    'tasks.total':           'Total',
    'tasks.completed':       'Completadas',
    'tasks.open':            'Abiertas',
    'tasks.task_created':    'Tarea creada',
    'tasks.task_updated':    'Tarea actualizada',
    'tasks.task_deleted':    'Tarea eliminada',

    // ── Sequences / Campaigns ──────────────────────────────────────────────────
    'sequences.title':           'Campañas',
    'sequences.new_campaign':    'Nueva Campaña',
    'sequences.search':          'Buscar campañas...',
    'sequences.loading':         'Cargando campañas...',
    'sequences.none':            'Sin campañas aún',
    'sequences.none_desc':       'Crea tu primera campaña de correo para comenzar.',
    'sequences.create':          'Crear Campaña',
    'sequences.edit':            'Editar Campaña',
    'sequences.delete':          'Eliminar Campaña',
    'sequences.confirm_delete':  '¿Seguro que deseas eliminar esta campaña?',
    'sequences.campaign_name':   'Nombre de la Campaña',
    'sequences.description':     'Descripción',
    'sequences.status':          'Estado',
    'sequences.active':          'Activa',
    'sequences.paused':          'Pausada',
    'sequences.completed':       'Completada',
    'sequences.steps':           'Pasos',
    'sequences.contacts':        'Contactos',
    'sequences.add_step':        'Agregar Paso',
    'sequences.step_delay':      'Retraso (días)',
    'sequences.email_subject':   'Asunto del Correo',
    'sequences.email_body':      'Cuerpo del Correo',
    'sequences.enroll_contacts': 'Inscribir Contactos',
    'sequences.enrolled':        'Inscritos',
    'sequences.all_types':       'Todos los Tipos',
    'sequences.day':             'día',
    'sequences.days':            'días',
    'sequences.delay':           'Retraso',
    'sequences.overview':        'Resumen',
    'sequences.sent':            'Enviados',
    'sequences.opened':          'Abiertos',
    'sequences.clicked':         'Clics',
    'sequences.replied':         'Respondidos',
    'sequences.unsubscribed':    'Desuscritos',

    // ── Social Calendar ────────────────────────────────────────────────────────
    'social.title':          'Calendario Social',
    'social.new_post':       'Nueva Publicación',
    'social.schedule':       'Programar',
    'social.publish':        'Publicar',
    'social.draft':          'Borrador',
    'social.published':      'Publicado',
    'social.scheduled':      'Programado',
    'social.loading':        'Cargando publicaciones...',
    'social.no_posts':       'Sin publicaciones aún',
    'social.create_post':    'Crear Publicación',
    'social.edit_post':      'Editar Publicación',
    'social.delete_post':    'Eliminar Publicación',
    'social.content':        'Contenido',
    'social.platform':       'Plataforma',
    'social.schedule_date':  'Fecha de Programación',
    'social.all_platforms':  'Todas las Plataformas',
    'social.all_statuses':   'Todos los Estados',

    // ── Reporting ──────────────────────────────────────────────────────────────
    'reporting.title':         'Reportes',
    'reporting.loading':       'Cargando reportes...',
    'reporting.no_data':       'Sin datos disponibles',
    'reporting.total_contacts':'Total de Contactos',
    'reporting.by_stage':      'Por Etapa',
    'reporting.by_type':       'Por Tipo',
    'reporting.by_source':     'Por Fuente',
    'reporting.win_rate':      'Tasa de Cierre',
    'reporting.activity':      'Actividad',
    'reporting.this_month':    'Este Mes',
    'reporting.all_time':      'Todo el Tiempo',

    // ── Documents ──────────────────────────────────────────────────────────────
    'documents.title':          'Documentos',
    'documents.new_document':   'Nuevo Documento',
    'documents.loading':        'Cargando documentos...',
    'documents.none':           'Sin documentos aún',
    'documents.upload':         'Subir Documento',
    'documents.send_for_sign':  'Enviar para Firma',
    'documents.signed':         'Firmado',
    'documents.pending':        'Pendiente',
    'documents.draft':          'Borrador',
    'documents.download':       'Descargar',
    'documents.delete':         'Eliminar',

    // ── QR Codes ───────────────────────────────────────────────────────────────
    'qrcodes.title':      'Códigos QR',
    'qrcodes.new':        'Nuevo Código QR',
    'qrcodes.loading':    'Cargando códigos QR...',
    'qrcodes.none':       'Sin códigos QR aún',
    'qrcodes.name':       'Nombre',
    'qrcodes.url':        'URL',
    'qrcodes.create':     'Crear Código QR',
    'qrcodes.download':   'Descargar',
    'qrcodes.delete':     'Eliminar',
    'qrcodes.scans':      'Escaneos',

    // ── Scheduling ─────────────────────────────────────────────────────────────
    'scheduling.title':       'Programación',
    'scheduling.coming_soon': 'Programación próximamente',

    // ── Settings ───────────────────────────────────────────────────────────────
    'settings.company_title':    'Configuración de Empresa',
    'settings.team_title':       'Miembros del Equipo',
    'settings.projects_title':   'Proyectos',
    'settings.company_name':     'Nombre de la Empresa',
    'settings.company_logo':     'Logo de la Empresa',
    'settings.upload_logo':      'Subir Logo',
    'settings.save_changes':     'Guardar Cambios',
    'settings.invite_member':    'Invitar Miembro',
    'settings.invite_email':     'Correo electrónico',
    'settings.send_invite':      'Enviar Invitación',
    'settings.member_name':      'Nombre',
    'settings.member_email':     'Correo',
    'settings.member_role':      'Rol',
    'settings.member_status':    'Estado',
    'settings.active':           'Activo',
    'settings.inactive':         'Inactivo',
    'settings.admin':            'Administrador',
    'settings.member':           'Miembro',
    'settings.loading_team':     'Cargando equipo...',
    'settings.no_team':          'Sin miembros aún',
    'settings.new_project':      'Nuevo Proyecto',
    'settings.project_name':     'Nombre del Proyecto',
    'settings.project_color':    'Color del Proyecto',
    'settings.project_desc':     'Descripción',
    'settings.create_project':   'Crear Proyecto',
    'settings.edit_project':     'Editar Proyecto',
    'settings.delete_project':   'Eliminar Proyecto',
    'settings.no_projects':      'Sin proyectos aún',
    'settings.loading_projects': 'Cargando proyectos...',

    // ── Auth ───────────────────────────────────────────────────────────────────
    'auth.login_title':     'Bienvenido de vuelta',
    'auth.login_desc':      'Inicia sesión en Stagehead OS',
    'auth.email':           'Correo',
    'auth.password':        'Contraseña',
    'auth.sign_in':         'Iniciar Sesión',
    'auth.signing_in':      'Iniciando sesión...',
    'auth.forgot_password': '¿Olvidaste tu contraseña?',
    'auth.loading':         'Cargando Stagehead OS...',
    'auth.accept_invite':   'Aceptar Invitación',
    'auth.create_account':  'Crear Cuenta',
    'auth.full_name':       'Nombre Completo',
  },
};
